import { useState } from 'react';
import { rm } from 'utils';
import { reloadCart } from 'components/Cart/actions';
import batchAction from 'store/batching';
import { AddressInfo } from 'models/AddressInfo';
import { CheckoutModal } from 'views/CheckoutPage/checkoutModal';
import { styled } from 'styled-components';
import { LabeledInput } from 'components/Shared/Form/LabeledInput/themes/BGH';
import { Button } from 'components/Button';
import { setAddressDetails } from 'views/CheckoutPage/actions';
import { useDispatch } from 'react-redux';
import { TooLongNameModalProps } from 'views/CheckoutPage/ContactInfo/TooLongNameModal/index';

const ContentWrapper = styled('div')({
  display: 'grid',
  gap: '2rem'
});

const InputWrapper = styled('div')(({ theme }) => ({
  gap: '1rem 2rem',
  display: 'grid',

  [theme.breakpoints.up('sm')]: {
    gap: '0.5rem 2rem',
    gridTemplateColumns: '1fr 1fr'
  }
}));

const ProgressSpan = styled('span')(({ theme }) => ({
  justifySelf: 'end',
  lineHeight: '1',

  [theme.breakpoints.up('sm')]: {
    gridColumn: '2'
  }
}));

export const TooLongNamePersonModal = ({ address, maxNameLength }: TooLongNameModalProps) => {
  const reduxDispatch = useDispatch();
  const [firstName, setFirstName] = useState(address.firstName);
  const [lastName, setLastName] = useState(address.lastName ?? '');

  const handleSubmit = () => {
    const newAddress: AddressInfo = {
      ...address,
      isTooLongName: false,
      hasNameOverride: true,
      firstName,
      lastName
    };

    reduxDispatch(batchAction(setAddressDetails(newAddress), reloadCart()));
  };

  const combinedLength = firstName.trim().length + (lastName.trim().length ?? 0);

  return (
    <CheckoutModal show={true}>
      <h2>{rm('checkout_too_long_name_header')}</h2>
      <ContentWrapper>
        <span>{rm('checkout_too_long_name_body', maxNameLength)}</span>

        <InputWrapper>
          <LabeledInput
            id="firstName"
            type="text"
            value={firstName}
            valid={combinedLength <= maxNameLength}
            label={rm('Checkout_firstname')}
            aria-invalid={combinedLength > maxNameLength}
            onChange={e => setFirstName(e.target.value)}
          />
          <LabeledInput
            id="lastName"
            label={rm('Checkout_lastname')}
            type="text"
            value={lastName}
            valid={combinedLength <= maxNameLength}
            aria-invalid={combinedLength > maxNameLength}
            onChange={e => setLastName(e.target.value)}
          />
          <ProgressSpan>
            ({combinedLength} / {maxNameLength})
          </ProgressSpan>
        </InputWrapper>

        <Button
          appearance="secondary"
          onClick={handleSubmit}
          disabled={combinedLength > maxNameLength}
        >
          {rm('checkout_modal_confirm')}
        </Button>
      </ContentWrapper>
    </CheckoutModal>
  );
};
